import React from 'react';
import { Text } from 'components/Text';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { getRelations } from 'helpers/Deal';
import './DealModalDeleteConfirmation.scss';
/**
 * @component DealModalDeleteConfirmation
 * @since 1.0.0
 * @hidden
 */
export function DealModalDeleteConfirmation(props) {
    const { onClose, item, type, configuration, deleteConfirmationMessage } = props;
    const { onItemDelete, onPackageDelete, onOptionsDelete, onOptionDelete } = useDealConfiguratorContext();
    const relatedOptions = getRelations(item.item, item.variant, configuration === null || configuration === void 0 ? void 0 : configuration.item, item.options, true);
    const filteredRelations = relatedOptions.filter((option) => option.type === 'CONDITIONAL');
    const relations = filteredRelations.map((option) => option.relatedSaleItem.id);
    const onConfirm = () => {
        switch (type) {
            case 'item':
                onItemDelete(item);
                break;
            case 'package':
                configuration && onPackageDelete(item, configuration);
                break;
            case 'options':
                onOptionsDelete(item);
                break;
            case 'option':
                configuration && onOptionDelete(item, configuration, relations);
                break;
        }
    };
    const footerActions = (React.createElement("div", { className: "deal-modal-delete-confirmation-container-footer" },
        React.createElement(Button, { label: t('Cancel'), onPress: onClose, noPadding: true }),
        React.createElement(Button, { style: "warning", picto: "xmark", label: t('Delete'), onPress: onConfirm })));
    return (React.createElement("div", { className: "deal-modal-delete-confirmation" },
        React.createElement(Modal, { title: t('Confirm'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-modal-delete-confirmation-content" },
                React.createElement(Text, { value: deleteConfirmationMessage }),
                React.createElement(Text, { value: t('This will delete the conditional option.') }),
                React.createElement(Text, { value: t('This action cannot be undone.') })))));
}
